import React from 'react';
import './index.css'
import EyeOpen from '../../../../../src/assets/svg_main/eye-open.svg';
import EditIcon from '../../../../../src/assets/svg_main/edit_outline.svg';
import DownArrow from '../../../../../src/assets/svg_main/downArrow.svg';
import UpArrow from '../../../../../src/assets/svg_main/upArrow.svg';
import Info from '../../../../../src/assets/svg_main/info.svg';
import PlusSvgIcon from '../../../../../src/assets/svg_main/plus.svg';
import dayjs from 'dayjs';
import PregnancyInfoBar from '../PregnancyTracking/PregnancyInfoBar';
import TooltipComponent from '@components/common/TooltipComponent';
import { useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import { benef_life_calendar_const } from '@constants/beneficiaryConstant';

interface commonServiceProps {
    isViewIcon?:boolean;
    isEditIcon?:boolean;
    isExpand?:boolean;
    status:string;
    isEndDateRequired: boolean;
    startDate:any;
    type?:string;
    endDate?:any;
    onAddClick?:(data:any) => void;
    isAddIcon?:boolean;
    serviceName:string;
    onViewClick?: (data:any) => void;
    onEditClick?: (data:any) => void;
    onExpand?:(data:any) => void;
    isExpanded?:boolean;
    isInfoRequired?:boolean;
    item?:any;
    complication?:any;
    serviceType?:any;
    isChildService?: boolean
}

const CommonServiceInfoBar = ({isViewIcon, isEditIcon, isExpand, status,type, isEndDateRequired, startDate, endDate, serviceName, onViewClick, onEditClick, onExpand, isExpanded, isInfoRequired, item, complication, serviceType, isChildService,isAddIcon,onAddClick}:commonServiceProps) => {
    const complications = complication?.join(', ');
    const pageMenuFromLifeCalendar = useSelector((state: RootState) => state.beneficiary.pageMenuFromLifeCalendar);

    const handleCheckFromLifeCalendar = () => {
        return (pageMenuFromLifeCalendar?.isNavigateFromLifeEvent && (!pageMenuFromLifeCalendar?.currentServices && !(pageMenuFromLifeCalendar?.naviGationType === benef_life_calendar_const.pregnancyStatus.on_going)))
      };

  return (
    <div className={`${isChildService && "child-common-infobar"} common-infobar-content`} key={serviceName} >
        <div className="common-infobar-header" >
            <div style={{ width: '24%'}}>{serviceName}</div>
            {!complication && <div style={{width: '10%'}} >{isInfoRequired && <PregnancyInfoBar item={item} />}</div>}
            {serviceType && <div style={{width: '15%', textAlign: 'center' }} >{serviceType}</div>}
            {complication && <div style={{width: '40%', textAlign: 'center', cursor: complications?.length > 25 ? 'pointer' : '' }} >{ complications?.length > 25 ? <TooltipComponent text={complications} >{complications?.slice(0, 25)}...</TooltipComponent> : complications }</div>}
            <div style={{ width: complication ? '20%' : '10.5%'}}>{startDate ? dayjs(startDate).format('DD-MM-YYYY') : ''}</div>
            {!complication &&  <div style={{ width: '20%' }}>{isEndDateRequired && endDate ? dayjs(endDate).format('DD-MM-YYYY') : ''}</div>}
            <div className="commonInfo-status-btns" >
                <div className={status?.toLowerCase()} >{status}</div>
                {!isExpand && <div className={`common-info-bar-buttons${type === 'newBorn' ? ' no-fill' : ''}`} >
                    {(isEditIcon && !handleCheckFromLifeCalendar()) && <span onClick={onEditClick}><EditIcon /></span>}
                    {isViewIcon && <span onClick={onViewClick} style={{marginLeft: isEditIcon ? '' : 'auto'}} ><EyeOpen /></span>}
                </div>}
                {isExpand && <span onClick={onExpand} className='common-expand-all' >{isExpanded ? <UpArrow /> : <DownArrow />}</span>}
                {isAddIcon && <div className='common-info-bar-add-button' onClick={onAddClick} ><PlusSvgIcon /></div>}
            </div>
        </div>
    </div>
  )
}

export default CommonServiceInfoBar
